if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-shop-look-dialog]');
        this.openers = Array.from(this.querySelectorAll('[data-shop-look-open]'));
        this.panels = Array.from(this.querySelectorAll('[data-shop-look-panel]'));
        this.closeButton = this.querySelector('[data-shop-look-close]');

        if (!this.dialog || !this.openers.length) return;

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDialogClick = this.handleDialogClick.bind(this);
        this.handleDialogClosed = this.handleDialogClosed.bind(this);

        this.openers.forEach((opener) => opener.addEventListener('click', this.handleOpen));
        this.closeButton?.addEventListener('click', this.handleClose);
        this.dialog.addEventListener('cancel', this.handleCancel);
        this.dialog.addEventListener('click', this.handleDialogClick);
        this.dialog.addEventListener('close', this.handleDialogClosed);
      }

      disconnectedCallback() {
        this.openers?.forEach((opener) => opener.removeEventListener('click', this.handleOpen));
        this.closeButton?.removeEventListener('click', this.handleClose);
        this.dialog?.removeEventListener('cancel', this.handleCancel);
        this.dialog?.removeEventListener('click', this.handleDialogClick);
        this.dialog?.removeEventListener('close', this.handleDialogClosed);
        document.body.classList.remove('shop-look-drawer-open');
      }

      handleOpen(event) {
        const opener = event.currentTarget;
        const lookId = opener?.dataset.shopLookOpen;
        const activePanel = this.panels.find((panel) => panel.dataset.shopLookPanel === lookId);

        if (!activePanel) return;

        this.activeOpener?.setAttribute('aria-expanded', 'false');
        this.activeOpener = opener;
        this.activeOpener.setAttribute('aria-expanded', 'true');
        this.panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
        });

        document.body.classList.add('shop-look-drawer-open');

        if (!this.dialog.open) {
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        }

        this.closeButton?.focus();
      }

      handleClose() {
        if (this.dialog.open && typeof this.dialog.close === 'function') {
          this.dialog.close();
          return;
        }

        this.dialog.removeAttribute('open');
        this.handleDialogClosed();
      }

      handleCancel(event) {
        event.preventDefault();
        this.handleClose();
      }

      handleDialogClick(event) {
        if (event.target === this.dialog) this.handleClose();
      }

      handleDialogClosed() {
        document.body.classList.remove('shop-look-drawer-open');
        this.panels.forEach((panel) => {
          panel.hidden = true;
        });
        this.activeOpener?.setAttribute('aria-expanded', 'false');
        this.activeOpener?.focus();
        this.activeOpener = null;
      }
    },
  );
}
